export default __webpack_public_path__ + "static/media/morpho.beb3bc8a.svg";